import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';

export const CatchupFormDialog = ({ open, onOpenChange, editing, form, setForm, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>
          {editing ? 'Edit Catch-up Student' : 'Enroll Student in Catch-up Programme'}
        </DialogTitle>
        <DialogDescription>
          Foundational learning support — record student details, parent contact, class teacher, and circumstances.
        </DialogDescription>
      </DialogHeader>
      <div className="grid gap-4 py-2">
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <Label>Student Name *</Label>
            <Input
              value={form.student_name}
              onChange={(e) => setForm({ ...form, student_name: e.target.value })}
              data-testid="catchup-name-input"
            />
          </div>
          <div className="space-y-1">
            <Label>Class / Grade</Label>
            <Input
              value={form.class_grade}
              onChange={(e) => setForm({ ...form, class_grade: e.target.value })}
              placeholder="e.g. P.3, S.1"
              data-testid="catchup-class-input"
            />
          </div>
          <div className="space-y-1">
            <Label>Class Teacher</Label>
            <Input
              value={form.class_teacher}
              onChange={(e) => setForm({ ...form, class_teacher: e.target.value })}
              data-testid="catchup-teacher-input"
            />
          </div>
          <div className="space-y-1">
            <Label>Class Teacher Contact</Label>
            <Input
              value={form.class_teacher_contact}
              onChange={(e) => setForm({ ...form, class_teacher_contact: e.target.value })}
              placeholder="Phone or email"
            />
          </div>
          <div className="space-y-1 col-span-2">
            <Label>Focus Subjects</Label>
            <Input
              value={form.focus_subjects}
              onChange={(e) => setForm({ ...form, focus_subjects: e.target.value })}
              placeholder="e.g. Math, English Reading"
            />
          </div>
        </div>

        <div className="border-t pt-3 space-y-3">
          <h4 className="font-semibold">Parent / Guardian</h4>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1 col-span-2">
              <Label>Name</Label>
              <Input
                value={form.parent_guardian_name}
                onChange={(e) => setForm({ ...form, parent_guardian_name: e.target.value })}
                data-testid="catchup-parent-name-input"
              />
            </div>
            <div className="space-y-1">
              <Label>Phone</Label>
              <Input
                value={form.parent_contact}
                onChange={(e) => setForm({ ...form, parent_contact: e.target.value })}
                data-testid="catchup-parent-contact-input"
              />
            </div>
            <div className="space-y-1">
              <Label>Email</Label>
              <Input
                type="email"
                value={form.parent_email}
                onChange={(e) => setForm({ ...form, parent_email: e.target.value })}
              />
            </div>
          </div>
        </div>

        <div className="border-t pt-3 space-y-3">
          <div className="space-y-1">
            <Label>Circumstances</Label>
            <Textarea
              rows={3}
              value={form.circumstances}
              onChange={(e) => setForm({ ...form, circumstances: e.target.value })}
              placeholder="Brief description of the student's circumstances (e.g. transferred mid-term, missed schooling due to illness, struggles with literacy)"
              data-testid="catchup-circumstances-input"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <Label>Enrollment Date</Label>
              <Input
                type="date"
                value={form.enrollment_date}
                onChange={(e) => setForm({ ...form, enrollment_date: e.target.value })}
              />
            </div>
            <div className="space-y-1">
              <Label>Status</Label>
              <Select
                value={form.status}
                onValueChange={(v) => setForm({ ...form, status: v })}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="enrolled">Enrolled</SelectItem>
                  <SelectItem value="active">Active</SelectItem>
                  <SelectItem value="graduated">Graduated</SelectItem>
                  <SelectItem value="withdrawn">Withdrawn</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="space-y-1">
            <Label>Progress Notes</Label>
            <Textarea
              rows={2}
              value={form.progress_notes}
              onChange={(e) => setForm({ ...form, progress_notes: e.target.value })}
              placeholder="Latest progress observations from the catch-up tutor"
            />
          </div>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onSubmit} data-testid="submit-catchup-btn">
          {editing ? 'Update' : 'Enroll'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
